import React from "react";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import CheckIcon from "@material-ui/icons/Check";

import RbScrollView from "components/RbScrollView";

const features = [
  "Beautiful and clean design",
  "Modern stack with React, Material UI and GraphQL",
  "Advanced responsive techniques with CSS and Javascript",
  "Examples of the most common screens and features",
  "Fully accessible",
  "More than 60 new components",
  "Use of Storybook for documentation and component development",
  "Theme color, contrast and dark mode configurated by users dinamically",
  "Simple and powerfull mocked GraphQL backend",
  "Modern state management with React hooks",
  "Easy form management and validation with integrated components",
];

function HomeScreen() {
  return (
    <RbScrollView p={{ xs: 4, md: 10 }}>
      <Typography variant="h3" paragraph>
        Welcome
      </Typography>
      <Typography variant="body1">
        Created to help teams to develop Enterprise React Applications providing
        common use cases, documentation and many components.
      </Typography>
      <br />
      <br />
      <Typography variant="h5">Features</Typography>
      <List dense>
        {features.map((feature) => (
          <ListItem key={feature}>
            <ListItemIcon>
              <CheckIcon />
            </ListItemIcon>
            <ListItemText primary={feature} />
          </ListItem>
        ))}
      </List>
    </RbScrollView>
  );
}

export default React.memo(HomeScreen);
